import React from 'react';

function ChatIcon({ size }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
      <path
        d="M 16.5 2 C 23.956 2 30 6.911 30 12.968 C 30 14.483 29.578 17.187 28.313 18.874 C 27.047 21.405 25.359 23.937 22.406 26.89 C 21.185 27.882 23.672 21.827 21.141 23.093 C 19.526 23.648 18.364 23.937 16.5 23.937 C 9.044 23.937 3 19.026 3 12.968 C 3 6.911 9.044 2 16.5 2 Z"
        fill="hsl(0, 0%, 100%)"
      />
      <path
        d="M 16.604 11.11 C 15.507 11.11 14.619 12.005 14.619 13.11 C 14.619 14.216 15.507 15.11 16.604 15.11 C 17.702 15.11 18.59 14.216 18.59 13.11 C 18.59 12.015 17.702 11.11 16.604 11.11 Z"
        fill="hsl(170, 0%, 75%)"
      />
      <path
        d="M 22.159 11.11 C 21.062 11.11 20.174 12.005 20.174 13.11 C 20.174 14.216 21.062 15.11 22.159 15.11 C 23.256 15.11 24.144 14.216 24.144 13.11 C 24.144 12.015 23.256 11.11 22.159 11.11 Z"
        fill="hsl(170, 0%, 75%)"
      />
      <path
        d="M 11.13 11.11 C 10.032 11.11 9.144 12.005 9.144 13.11 C 9.144 14.216 10.032 15.11 11.13 15.11 C 12.227 15.11 13.115 14.216 13.115 13.11 C 13.105 12.015 12.217 11.11 11.13 11.11 Z"
        fill="hsl(170, 0%, 75%)"
      />
    </svg>
  );
}
ChatIcon.defaultProps = {
  size: 32,
};

export default ChatIcon;
